import { CompanyT } from "../store/slices/company.slice"
import { useCompanyStats } from "./useCompanyStats"

const BYTES_PER_MB = 1000000
const TOTAL_LIMIT_MB = 256

type StorageLimit = {
    usedStorageMB: number
    usedStoragePercent: number
    isStorageWarning: boolean
    isStorageLimitExceeded: boolean
}

const useStorageLimit = (selectedCompany?: CompanyT): StorageLimit => {
    const { spaceUsed } = useCompanyStats({ id: selectedCompany?._id })
    const isPrivate = !!selectedCompany?.isPrivate

    if (!isPrivate) {
        return {
            usedStorageMB: 0,
            usedStoragePercent: 0,
            isStorageWarning: false,
            isStorageLimitExceeded: false,
        }
    }

    const usedStorageMB = Number((spaceUsed / BYTES_PER_MB).toFixed(2))
    const usedStoragePercent = Number(((usedStorageMB / TOTAL_LIMIT_MB) * 100).toFixed(2))

    //is more then 99% of 256MB => show alert dialog but not allow editing navigate into gallery to clear space
    const isStorageLimitExceeded = usedStoragePercent >= 99

    //is more then 90% of 256MB => show alert dialog just info about space
    const isStorageWarning = !isStorageLimitExceeded && usedStoragePercent > 90

    return {
        usedStorageMB,
        usedStoragePercent,
        isStorageWarning,
        isStorageLimitExceeded,
    }
}

export default useStorageLimit
